'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Modal = require('./Modal.scss');

var _Modal2 = _interopRequireDefault(_Modal);

var _reactRedux = require('react-redux');

var _lockscreen = require('redux/modules/lockscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Modal: {
    displayName: 'Modal'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/Modal/Modal.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


var Modal = _wrapComponent('Modal')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isOpenChat: state.trip.openChat,
    isOpenLoginSignup: state.session.openLoginSignup
  };
}, { addId: _lockscreen.addId, removeId: _lockscreen.removeId }), _dec2 = (0, _reactCssModules2.default)(_Modal2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getModalClass = function () {
      if (_this.props.isOpen && _this.props.centerVertical) {
        return 'modal-center-open';
      } else if (_this.props.isOpen) {
        return 'modal-open';
      }
      return 'modal';
    }, _this.innerClick = function (event) {
      event.stopPropagation();
    }, _this.close = function (event) {
      event.preventDefault();
      _this.props.onClose();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      if (this.props.isOpen === false && props.isOpen === true && this.props.id) {
        this.props.addId(this.props.id);
        // document.body.className = document.body.className.search('hide-zopim') < 0 ? 'lock-screen' : 'lock-screen hide-zopim';
        // } else if (this.props.isOpenLoginSignup && this.props.isOpenChat) {
        // console.log('close');
      } else if (this.props.isOpen === true && props.isOpen === false && this.props.id) {
        this.props.removeId(this.props.id);
        // document.body.className = document.body.className.search('hide-zopim') < 0 ? '' : 'hide-zopim';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.id) {
        this.props.removeId(this.props.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // if (this.props.isOpen) {
      return _react3.default.createElement(
        'div',
        null,
        this.props.isOpen && _react3.default.createElement(
          'div',
          { styleName: this.getModalClass(), onClick: this.close, style: this.props.zIndex ? { 'zIndex': this.props.zIndex } : null, key: 'modal' },
          _react3.default.createElement(
            'div',
            { styleName: 'modal-content', style: this.props.style, onClick: this.innerClick },
            this.props.noClose ? null : _react3.default.createElement('a', { styleName: this.props.closeStyle || 'btn-close', onClick: this.close, 'data-tmt': 'modal-close' }),
            this.props.children
          )
        )
      );
      // }
      // return <div></div>;
    }
  }]);
  return Modal;
}(_react2.Component), _class2.propTypes = {
  isOpen: _react2.PropTypes.bool,
  children: _react2.PropTypes.element,
  onClose: _react2.PropTypes.func,
  fullWidth: _react2.PropTypes.bool,
  noClose: _react2.PropTypes.bool,
  centerVertical: _react2.PropTypes.bool,
  isOpenChat: _react2.PropTypes.bool,
  isOpenLoginSignup: _react2.PropTypes.bool,
  closeStyle: _react2.PropTypes.string,
  style: _react2.PropTypes.object,
  zIndex: _react2.PropTypes.number,
  id: _react2.PropTypes.string,
  addId: _react2.PropTypes.func,
  removeId: _react2.PropTypes.func
}, _class2.defaultProps = {
  isOpen: false,
  noclose: false,
  centerVertical: false,
  closeStyle: '',
  style: {},
  onClose: function onClose() {}
}, _temp2)) || _class) || _class));

exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/Modal/Modal.js
// module id = 55
// module chunks = 47